import { useState, useEffect, useContext } from "react";
import { AiOutlineLink } from "react-icons/ai";
import Pagination from "rc-pagination";
import toast from "react-hot-toast";
import { NavLink } from "react-router-dom";
import Select from "react-select";
import { Tabs, Tab } from "react-bootstrap";
import { addCommas } from "@persian-tools/persian-tools";

import WebInfoContext from "context/WebInfo/WebInfoContext.ts";
import useAxios from "services/useAxios.tsx";
import Loader from "Components/kits/Loader/Loader.tsx";
import { pathMaker } from "utils/helperFunctions";

import placeholder from "../../../assets/images/placeholder-image.png";
import ReportCard from "./ReportCard";
import "./style.scss";
import "rc-pagination/assets/index.css";

export default function ReportProductFactor() {
  const { execute: getListApi } = useAxios("factor/factoItemListReport");
  const { execute: getProductListApi } = useAxios("factor/productReport");

  const { categorys } = useContext(WebInfoContext);

  const [list, setList] = useState([]);
  const [productList, setProductList] = useState([]);
  const [listUpdater, setListUpdater] = useState(false);
  const [check, setCheck] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingProduct, setLoadingProduct] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    count: 20,
    total: 0,
  });
  const [productPagination, setProductPagination] = useState({
    page: 1,
    count: 20,
    total: 0,
  });
  const [statistics, setStatistics] = useState({
    warehouse: { amount: 0, count: 0 },
    product: {
      order_amount_delivery: 0,
      order_amount: 0,
      order_count: 0,
      shop_count: 0,
      shop_amount: 0,
    },
  });
  const [hashtags, setHashtags] = useState([]);
  const [selectedHashtag, setSelectedHashtag] = useState({});

  const translateToHashtag = (array) => {
    let temp = array?.map((value) => ({
      value: value?.hashtag?.id,
      label: value?.hashtag?.txt,
    }));
    return temp;
  };
  const calculateStatisticsData = (array) => {
    let pageReportCount = 0;
    let pageReportAmount = 0;
    let newArray = array?.map((data) => {
      let buyAmount = +data?.count * (+data?.per_price - +data?.per_discount);
      let inventoryStore = 0;
      let inventoryWareHouse = 0;
      let sellAmount = 0;
      let sellCount = 0;
      let inventoryAmountStore = 0;
      let inventoryAmountWareHouse = 0;
      let connectToProduct = 0;
      let temp = {
        ...data,
        product: data?.product?.map((value) => {
          value?.inventory?.map((val) => {
            inventoryStore += +val?.inventory;
            inventoryAmountStore +=
              +val?.inventory *
              (+val?.price - +val?.price * (+val?.discount / 100));
          });
          value?.order_item_data?.map((val) => {
            sellCount += +val?.itemcount;
            if (val?.discount_type == 0) {
              sellAmount +=
                +val?.itemcount *
                (+val?.main_price - +val?.price * (+val?.discount / 100));
            } else {
              sellAmount +=
                +val?.itemcount * (+val?.main_price - +val?.main_discount);
            }
          });
          connectToProduct += +value?.count;
          return value;
        }),
        statistics: {
          buyAmount,
          connectToProduct,
        },
      };

      pageReportCount += data?.count - connectToProduct;
      pageReportAmount +=
        (data?.count - connectToProduct) *
        (+data?.per_price - +data?.per_discount);
      console.log("statistics", pageReportAmount, pageReportCount);

      return temp;
    });
    setStatistics((prev) => ({
      ...prev,
      warehouse: { count: pageReportCount, amount: pageReportAmount },
    }));
    return newArray;
  };
  const getProductListFunc = async () => {
    setLoadingProduct(true);
    let payload = {
      page: productPagination?.page,
      count: productPagination?.count,
    };
    if (selectedHashtag?.value != undefined) {
      payload = { ...payload, hashtag_id: selectedHashtag?.value };
    }
    await getProductListApi(payload).then((res) => {
      setLoadingProduct(false);
      setProductPagination((prev) => ({ ...prev, total: res?.total }));
      setStatistics((prev) => ({
        ...prev,
        product: {
          order_amount: res?.statistics?.sell_amount,
          order_amount_delivery: res?.statistics?.sell_amount_puls_delivary,
          order_count: res?.statistics?.all_sell,
          shop_amount: res?.statistics?.inventory_amount,
          shop_count: res?.statistics?.all_inventory,
          buy_amount: res?.statistics?.buy_amount,
          buy_count: res?.statistics?.buy_count,
        },
      }));
      let tempProduct = res?.product?.map((value) => {
        let tempInventory = 0;
        let orderCount = 0;
        let orderAmount = 0;
        let tempAmount = 0;
        let factorCount = 0;
        let factorAmount = 0;
        value?.order_items?.map((oValue) => {
          orderCount += +oValue?.itemcount;
          if (oValue?.discount_type == 0) {
            orderAmount +=
              +oValue?.itemcount *
              (+oValue?.main_price -
                (+oValue?.main_price * +oValue?.main_discount) / 100);
          } else {
            orderAmount +=
              +oValue?.itemcount *
              (oValue?.main_price - +oValue?.main_discount);
          }
        });

        value?.product_price?.map((pValue) => {
          tempInventory += parseInt(pValue?.inventory);
          tempAmount +=
            +pValue?.inventory *
            (+pValue?.price - (+pValue?.price * +pValue?.discount) / 100);
        });

        value?.factor_items?.map((fValue) => {
          factorCount += +fValue?.link_count;
          factorAmount +=
            +fValue?.link_count * (+fValue?.per_price - +fValue?.per_discount);
        });
        return {
          ...value,
          inventoryCount: tempInventory,
          orderAmount,
          orderCount,
          inventoryAmount: tempAmount,
          factorCount,
          factorAmount,
        };
      });
      setProductList(tempProduct);
    });
  };
  useEffect(() => {
    async function loadPage(params) {
      setLoading(true);
      await getListApi({
        page: pagination?.page,
        count: pagination?.count,
      }).then((result) => {
        if (result?.status == 1) {
          setList(calculateStatisticsData(result?.data));
          setPagination((prev) => ({ ...prev, total: result?.total }));

          if (check) {
            toast.success("بررسی مجدد انجام شد.");
            setCheck(false);
          }
        } else {
          toast.error(result?.msg);
        }
        setLoading(false);
      });
    }
    loadPage();
  }, [pagination?.page, listUpdater]);

  useEffect(() => {
    async function loadPage() {
      await getProductListFunc();
    }
    loadPage();
  }, [productPagination?.page, selectedHashtag]);

  useEffect(() => {
    setHashtags(translateToHashtag(categorys));
  }, [categorys]);

  return (
    <div className="m-4 style">
      <Tabs defaultActiveKey={"factor"}>
        <Tab eventKey="factor" title="بر اساس خرید">
          {loading ? (
            <div
              className="w-100 d-flex align-items-center justify-content-center"
              style={{ height: "50vh" }}
            >
              <Loader width={40} />
            </div>
          ) : (
            <>
              <div className="d-flex flex-wrap mx-auto col-12 col-lg-8">
                <div className="w-100 d-flex justify-content-center">
                  <ReportCard
                    array={[
                      {
                        title: "گزارش آیتمهای این صفحه",
                        value: "",
                        customClass: "bg-bl-04",
                      },
                    ]}
                  />
                </div>
                <ReportCard
                  array={[
                    {
                      title: "موجودی ریالی انبار",
                      value: `${addCommas(
                        statistics?.warehouse?.amount
                      )} تومان`,
                      customClass: "bg-bl-08",
                    },
                    {
                      title: "تعداد موجود در انبار",
                      value: statistics?.warehouse?.count,
                      customClass: "bg-bl-08",
                    },
                  ]}
                />
              </div>
              {list?.map((value, index) => (
                <Item data={value} index={index} />
              ))}
              <div className="d-flex justify-content-center mt-4">
                <div>
                  <Pagination
                    className="px-1"
                    total={pagination?.total}
                    pageSize={pagination?.count}
                    current={pagination?.page}
                    onChange={(newPage) => {
                      setPagination((prev) => ({ ...prev, page: newPage }));
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </Tab>
        <Tab eventKey={"product"} title="بر اساس محصول">
          {loadingProduct ? (
            <div
              className="w-100 d-flex align-items-center justify-content-center"
              style={{ height: "50vh" }}
            >
              <Loader width={40} />
            </div>
          ) : (
            <>
              <div className="col-12 col-sm-6 col-md-4 my-1 mx-auto">
                <p className="font-14-500">دسته بندی</p>
                <Select
                  options={hashtags}
                  value={selectedHashtag}
                  isClearable
                  onChange={(e, action) => {
                    if (action?.action == "clear") {
                      setSelectedHashtag("");
                    } else {
                      setSelectedHashtag(e);
                    }
                  }}
                />
              </div>
              <div className="d-flex flex-wrap mx-auto col-12 col-lg-8">
                <div className="w-100 d-flex justify-content-center">
                  <ReportCard
                    array={[
                      {
                        title: "تعداد آیتم بررسی شده",
                        value: productPagination?.total,
                        customClass: "bg-bl-04",
                      },
                    ]}
                  />
                </div>
                <ReportCard
                  array={[
                    {
                      title: "تعداد اقلام فروخته شده",
                      value: statistics?.product?.order_count,
                      customClass: "bg-bl-08",
                    },
                    {
                      title: "مجموع سفارشات تا این لحظه",
                      value: `${addCommas(
                        statistics?.product?.order_amount
                      )} تومان`,
                      customClass: "bg-bl-08",
                    },
                    {
                      title: "موجودی اقلام",
                      value: statistics?.product?.shop_count,
                      customClass: "bg-bl-08",
                    },
                    {
                      title: "مجموع موجودی ریالی",
                      value: `${addCommas(
                        statistics?.product?.shop_amount
                      )} تومان`,
                      customClass: "bg-bl-08",
                    },
                    {
                      title: "تعداد اقلام خرید",
                      value: statistics?.product?.buy_count,
                      customClass: "bg-bl-08",
                    },
                    {
                      title: "مجموع خرید(کل خریدهای متصل به محصول)",
                      value: `${addCommas(
                        statistics?.product?.buy_amount
                      )} تومان`,
                      customClass: "bg-bl-08",
                    },
                  ]}
                />
              </div>
              {productList?.map((value, index) => (
                <ItemProduct data={value} index={index} />
              ))}
              <div className="d-flex justify-content-center mt-4">
                <div>
                  <Pagination
                    className="px-1"
                    total={productPagination?.total}
                    pageSize={productPagination?.count}
                    current={productPagination?.page}
                    onChange={(newPage) => {
                      setProductPagination((prev) => ({
                        ...prev,
                        page: newPage,
                      }));
                    }}
                  />
                </div>
              </div>
            </>
          )}
        </Tab>
      </Tabs>
    </div>
  );
}

const Item = ({ data, index }) => {
  // const [statistics, setStatistics] = useState({});
  // useEffect(() => {
  //   let inventoryStore = 0;
  //   let inventoryWareHouse = 0;
  //   let sellAmount = 0;
  //   let sellCount = 0;
  //   let inventoryAmountStore = 0;
  //   let inventoryAmountWareHouse = 0;
  //   let connectToProduct = 0;
  //   let buyAmount = +data?.count * (+data?.per_price - +data?.per_discount);
  //   data?.product?.map((value) => {
  //     value?.inventory?.map((val) => {
  //       inventoryStore += +val?.inventory;
  //       inventoryAmountStore +=
  //         +val?.inventory *
  //         (+val?.price - +val?.price * (+val?.discount / 100));
  //     });
  //     value?.order_item_data?.map((val) => {
  //       sellCount += +val?.itemcount;
  //       sellAmount +=
  //         +val?.itemcount * (+val?.main_price - +val?.main_discount);
  //     });
  //     connectToProduct += +value?.count;
  //   });
  //   inventoryWareHouse = +data?.count - (inventoryStore + sellCount);
  //   setStatistics({
  //     inventoryStore,
  //     sellCount,
  //     buyAmount,
  //     sellAmount,
  //     inventoryWareHouse,
  //     inventoryAmountStore,
  //     connectToProduct,
  //   });
  // }, [data]);
  return (
    <div
      className={`d-flex flex-wrap my-4 font-14-500 ${
        index % 2 == 0 ? "bg-yel" : "bg-bl"
      }`}
    >
      <div className="contain wp-80">
        <div className="title">شناسه فاکتور</div>
        <div className="value">{data?.factor_id} </div>
      </div>
      <div className="contain wp-100">
        <div className="title">نام فاکتور</div>
        <div className="value"> {data?.store_title}</div>
      </div>
      <div className="contain wp-100">
        <div className="title">شناسه آیتم فاکتور</div>
        <div className="value">{data?.id} </div>
      </div>
      <div className="contain wp-200">
        <div className="title">نام آیتم فاکتور</div>
        <div className="value">{data?.title} </div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">تعداد خریداری شده(فاکتور)</div>
        <div className="value">{data?.count}</div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">مجموع مبلغ خریداری شده</div>
        <div className="value">
          {addCommas(data?.statistics?.buyAmount)} تومان
        </div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">تعداد متصل به محصول</div>
        <div className="value">
          {addCommas(data?.statistics?.connectToProduct)}
        </div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">موجود در انبار</div>
        <div className="value">
          {data?.count - data?.statistics?.connectToProduct}
        </div>
      </div>

      <div className="w-100 contain">
        <div className="title">محصولات لینک شده</div>
        <div className="value d-flex align-items-center justify-content-start">
          {data?.product?.length > 0 ? (
            <ol className="w-100">
              {data?.product?.map((v) => {
                return (
                  <li className="mr-t-10">
                    <div className="d-flex  flex-wrap align-items-center">
                      <div className="col-6 col-md-2">
                        <img
                          src={
                            v?.file?.length > 0
                              ? pathMaker(v?.file?.[0]?.url)
                              : placeholder
                          }
                          style={{ width: 60, height: 60, objectFit: "cover" }}
                          className="rounded m-2 "
                        />
                      </div>
                      <div className="col-6 col-md-2">
                        <div
                          className="mr-l-16 text-start col-6 col-md-2"
                          style={{ width: 200 }}
                        >
                          <div className="fw-bold">نام محصول</div>
                          <div>{v?.title}</div>
                        </div>
                      </div>
                      {/* <div className="mr-l-16 mx-4">
                        <div className="fw-bold">موجودی (شرایط فروش)</div>
                        <div>
                          {v?.sum_inventory?.[0]?.sum_inventory ?? "--"}
                        </div>
                      </div>
                      <div className="mr-l-16 mx-4">
                        <div className="fw-bold">انبارداری</div>
                        {v?.count}
                        <div></div>
                      </div> */}
                      <div className="pd-x-8 col-11 col-md-7 flex-grow-1">
                        <div className="fw-bold">سفارشات</div>
                        <div>
                          {v?.order_item_data?.length > 0 ? (
                            <div>
                              {v?.order_item_data?.map((val, ind) => {
                                return (
                                  <span>
                                    سفارش شماره {val?.order_id}({val?.itemcount}
                                    عدد)
                                    {ind < v?.order_item_data?.length - 1
                                      ? ", "
                                      : ""}
                                  </span>
                                );
                              })}
                            </div>
                          ) : (
                            <div>سفارشی برای این محصول ثبت نشده است.</div>
                          )}
                        </div>
                      </div>
                      <div className="col-1">
                        <NavLink
                          to={`/product/${v?.product_id}`}
                          target="_blank"
                          className="text-decoration-none bg-success rounded p-2  "
                        >
                          <AiOutlineLink
                            color="white"
                            style={{ width: 15, height: 15 }}
                          />
                        </NavLink>
                      </div>
                    </div>
                    <hr />
                  </li>
                );
              })}
            </ol>
          ) : (
            <div>محصولی به آیتم فاکتور لینک نشده است.</div>
          )}
        </div>
      </div>
    </div>
  );
};

const ItemProduct = ({ data, index }) => {
  console.log("debug s", data);
  return (
    <div
      className={`d-flex flex-wrap my-4 font-14-500 ${
        index % 2 == 0 ? "bg-yel" : "bg-bl"
      }`}
    >
      <NavLink
        to={pathMaker(data?.file?.[0]?.url)}
        className={""}
        style={{ border: "1px solid navy" }}
        target="_blank"
      >
        <img
          src={pathMaker(data?.file?.[0]?.url)}
          style={{ width: 80, height: "100%", objectFit: "cover" }}
        />
      </NavLink>
      <div className="contain wp-80">
        <div className="title">شناسه محصول</div>
        <div className="value">{data?.id} </div>
      </div>
      <div className="contain wp-100">
        <div className="title">نام محصول</div>
        <div className="value"> {data?.title}</div>
      </div>
      <div className="contain wp-80">
        <div className="title">وضعیت محصول</div>
        <div className="value">
          {data?.status == 0
            ? "فعال"
            : data?.status == -1
            ? "غیرفعال"
            : data?.status == -2
            ? "حذف شده"
            : "نامشخص"}{" "}
        </div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">موجودی</div>
        <div className="value">
          {data?.status == -2 && data?.inventoryCount != 0 ? (
            <>
              <span
                style={{
                  textDecoration: "line-through red dashed",
                }}
              >
                {data?.inventoryCount}
              </span>
              <span className="ms-2">0</span>
            </>
          ) : (
            data?.inventoryCount
          )}
        </div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">موجودی ریالی</div>
        <div className="value">{addCommas(data?.inventoryAmount)} تومان</div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">تعداد خرید</div>
        <div className="value">{data?.factorCount} </div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">مجموع خرید</div>
        <div className="value">{addCommas(data?.factorAmount)} تومان</div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">تعداد فروش</div>
        <div className="value">{data?.orderCount} </div>
      </div>
      <div className="contain wp-100 ">
        <div className="title">مجموع فروش</div>
        <div className="value">{addCommas(data?.orderAmount)} تومان</div>
      </div>

      <div className="w-100 contain">
        <div className="title">فاکتور آیتمهای لینک شده</div>
        <div className="value d-flex align-items-center justify-content-start">
          {data?.factor_items?.length > 0 ? (
            <ol className="w-100">
              {data?.factor_items?.map((v) => {
                return (
                  <li className="mr-t-10">
                    <div className="d-flex  flex-wrap align-items-center w-100">
                      <div className="col-6 col-md-2">
                        <div
                          className="mr-l-16 text-start  "
                          // style={{ width: 200 }}
                        >
                          <div className="fw-bold">شناسه فاکتور</div>
                          <div>{v?.factor_id}</div>
                        </div>
                      </div>
                      <div className="col-6 col-md-2">
                        <div
                          className="mr-l-16 text-start  "
                          // style={{ width: 200 }}
                        >
                          <div className="fw-bold">شناسه آیتم فاکتور</div>
                          <div>{v?.id}</div>
                        </div>
                      </div>
                      <div className="col-12 col-sm-6 col-md-4 ">
                        <div
                          className="mr-l-16 text-start  "
                          // style={{ width: 200 }}
                        >
                          <div className="fw-bold">عنوان محصول در فاکتور</div>
                          <div>{v?.title}</div>
                        </div>
                      </div>
                      <div className="col-6 col-sm-3 col-md-2 ">
                        <div
                          className="mr-l-16 text-start  "
                          // style={{ width: 200 }}
                        >
                          <div className="fw-bold">تعداد</div>
                          <div>{v?.link_count}</div>
                        </div>
                      </div>
                      <div className="col-6 col-sm-3 col-md-2 ">
                        <div
                          className="mr-l-16 text-start  "
                          // style={{ width: 200 }}
                        >
                          <div className="fw-bold">مجموع</div>
                          <div>
                            {addCommas(
                              +v?.link_count *
                                (+v?.per_price - +v?.per_discount)
                            )}{" "}
                            تومان
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr />
                  </li>
                );
              })}
            </ol>
          ) : (
            <div>فاکتورآیتمی به این محصول لینک نشده است.</div>
          )}
        </div>
      </div>
    </div>
  );
};
